import { jsx as _jsx } from "react/jsx-runtime";
import { loginSuccessCallback } from "@/store/User/loginSuccessCallback";
import { popupReducer, usePopups } from "@/store/popups";
import { NewLoginPopup } from "../NewLoginPopup";
// 登录弹窗
export const popupLogin = params => {
  console.log("params?.onSuccess", params);
  const _params = {
    ...params
  };
  if (_params.onSuccess) {
    loginSuccessCallback.setCallback(_params.onSuccess); // 登陆成功后的回调, 会在handler里面的updateUserInfo里面调用
  }
  const payload = {
    type: "ss",
    visible: true,
    content: /*#__PURE__*/_jsx(NewLoginPopup, {
      ..._params
    }),
    drawerAttributes: {
      placement: "bottom",
      height: "100%",
      style: {
        background: "transparent",
        width: "auto",
        height: "auto",
        bottom: 0,
        top: 0,
        right: 0,
        left: 0
      },
      maskStyle: {
        background: "rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(12px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      headerStyle: {
        background: "#000"
      },
      bodyStyle: {
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
      },
      maskClosable: true,
      escToExit: true
    }
  };
  usePopups.setState(state => {
    popupReducer.pushStack(state, payload);
  });
};
export const closeTopPopup = () => {
  usePopups.setState(state => {
    popupReducer.popStack(state);
  });
};